"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentsSearchField = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var index_1 = require("../../index");
var SearchResultsService_1 = require("../services/SearchResultsService");
var LoadingSpinner_1 = require("Views/Partials/Components/LoadingSpinner/LoadingSpinner");
var DocumentsSearchField = /** @class */ (function (_super) {
    tslib_1.__extends(DocumentsSearchField, _super);
    function DocumentsSearchField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputRef = React.createRef();
        _this.state = {
            typedSearchValue: _this.props.query || '',
            prevQuery: _this.props.query,
            isLoading: false,
        };
        _this.getDocumentsCount = function () {
            var typeFiltersList = _this.props.typeFiltersList;
            var documentationTypeFilter = typeFiltersList.filter(function (filter) {
                return filter &&
                    filter.value &&
                    SearchResultsService_1.SearchResultsService.getFilterValueItself(filter.value) ===
                        _this.props.documentsSearchPageType;
            })[0];
            return (documentationTypeFilter && documentationTypeFilter.documentsCount) || 0;
        };
        _this.onInputChange = function (event) {
            _this.setState({ typedSearchValue: event.target.value });
        };
        _this.onInputKeyDown = function (event) {
            if (!(event.key === 'Enter')) {
                return;
            }
            if (_this.state.typedSearchValue ||
                (_this.state.prevQuery && _this.state.typedSearchValue === '')) {
                _this.setState({ isLoading: true });
                _this.props.setIsContentLoading(true);
                _this.props.onChangeQuery(_this.state.typedSearchValue, true);
            }
        };
        _this.onSearchIconClick = function () {
            if (_this.state.typedSearchValue ||
                (_this.state.prevQuery && _this.state.typedSearchValue === '')) {
                _this.setState({ isLoading: true });
                _this.props.setIsContentLoading(true);
                _this.props.onChangeQuery(_this.state.typedSearchValue, true);
            }
        };
        _this.onSearchClearIconClick = function () {
            _this.setState({ isLoading: true });
            _this.props.setIsContentLoading(true);
            _this.props.onChangeQuery('');
            _this.inputRef.current.focus();
        };
        return _this;
    }
    DocumentsSearchField.getDerivedStateFromProps = function (nextProps, prevState) {
        if (prevState.prevQuery === (nextProps === null || nextProps === void 0 ? void 0 : nextProps.query)) {
            return { isLoading: false };
        }
        if (nextProps.query !== prevState.prevQuery) {
            return { typedSearchValue: nextProps.query, prevQuery: nextProps.query };
        }
        return null;
    };
    DocumentsSearchField.prototype.componentDidUpdate = function (_, prevState) {
        if (this.state.isLoading !== prevState.isLoading) {
            this.props.setIsContentLoading(this.state.isLoading);
        }
    };
    DocumentsSearchField.prototype.componentWillUnmount = function () {
        this.props.setIsContentLoading(false);
    };
    DocumentsSearchField.prototype.render = function () {
        var cancelable = this.state.prevQuery && this.state.prevQuery.length > 0;
        var dictionary = index_1.PageContext.dictionary;
        return (React.createElement("div", { className: "filterable-list__documents-search-section-container" },
            React.createElement("span", { className: "filterable-list__documents-count" }, dictionary === null || dictionary === void 0 ? void 0 :
                dictionary.numberOfItems,
                ": ",
                this.getDocumentsCount()),
            React.createElement("div", { className: "filterable-list__documents-search-field-container" },
                React.createElement("button", { className: "clickable-icon-container", "aria-label": dictionary === null || dictionary === void 0 ? void 0 : dictionary.searchButton, onClick: cancelable ? this.onSearchClearIconClick : this.onSearchIconClick }, cancelable ? (React.createElement("span", { className: "icon icon-cancel", "aria-hidden": "true" })) : (React.createElement("span", { className: "icon icon-search", "aria-hidden": "true" }))),
                React.createElement("input", { className: "filterable-list__documents-search-field", type: "text", "aria-label": dictionary === null || dictionary === void 0 ? void 0 : dictionary.search, value: this.state.typedSearchValue, placeholder: dictionary === null || dictionary === void 0 ? void 0 : dictionary.searchInResultsPlaceholder, onChange: this.onInputChange, onKeyDown: this.onInputKeyDown, ref: this.inputRef }),
                React.createElement(LoadingSpinner_1.default, { visible: this.state.isLoading, className: "filterable-list__documents-search-field-spinner" }))));
    };
    return DocumentsSearchField;
}(React.PureComponent));
exports.DocumentsSearchField = DocumentsSearchField;
